import type { UseFormReturn } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import type { NotificationCheckboxesValues } from './types';

export enum DataBoxNotificationToggleInputName {
	Sms = 'enabledSms',
	Email = 'enabledEmail',
	EmailAttachment = 'enabledEmailAttachment',
}

type NotificationSettingsForm = UseFormReturn<{
	[databoxId: string]: NotificationCheckboxesValues;
}>;

export const FormInstance = (databoxId: string): NotificationSettingsForm => {
	const methods = useForm({
		defaultValues: {
			[databoxId]: {
				[DataBoxNotificationToggleInputName.Sms]: false,
				[DataBoxNotificationToggleInputName.Email]: false,
				[DataBoxNotificationToggleInputName.EmailAttachment]: false,
			},
		},
	});

	return methods;
};

export const setNotificationCheckboxesValues = (
	form: NotificationSettingsForm,
	databoxId: string,
	complextValue: NotificationCheckboxesValues
): void => {
	form.setValue(
		`${databoxId}.${DataBoxNotificationToggleInputName.Sms}`,
		complextValue.enabledSms
	);
	form.setValue(
		`${databoxId}.${DataBoxNotificationToggleInputName.Email}`,
		complextValue.enabledEmail
	);
	form.setValue(
		`${databoxId}.${DataBoxNotificationToggleInputName.EmailAttachment}`,
		complextValue.enabledEmailAttachment
	);
};

export const setExtendedNotification = (
	form: NotificationSettingsForm,
	databoxId: string,
	value: boolean
): void => {
	if (value) {
		form.setValue(
			`${databoxId}.${DataBoxNotificationToggleInputName.Email}`,
			true
		);
	}
	form.setValue(
		`${databoxId}.${DataBoxNotificationToggleInputName.EmailAttachment}`,
		value
	);
};
